<template>
  <div>
    <app-rank-type />
    <app-view-rank-type />
    <app-create-rank-type />
  </div>
</template>

<script>

    import IndexRankTypes from "../../../components/setup/rank_types/IndexRankTypes";
    import ViewRankTypes from "../../../components/setup/rank_types/ViewRankTypes";
    import CreateRankTypes from "../../../components/setup/rank_types/CreateRankTypes";

    export default {
        name: "RankType",
        components: {
            'app-rank-type': IndexRankTypes,
            'app-view-rank-type': ViewRankTypes,
            'app-create-rank-type': CreateRankTypes
        }
    }
</script>

<style scoped>

</style>
